<template>
    <div id="music" @click="musicSwitch" :class="{musicshow:muiscIsPlay}">
      <audio  loop autoplay="autoplay" src="https://t.shundecity.com/bjls2021/Home/View/index/music/bgm.mp3" id="musicplay"></audio>
    </div>
</template>
<script>
export default {
    data(){
        return{
            muiscIsPlay:true
        }
    },
    watch:{
        '$route' (to,from){
            var _this = this;
            var player = document.getElementById('musicplay')
            if(to.path=='/wqsd'){
                 player.pause();
                _this.muiscIsPlay = false
                
            }else{
                player.play();
                _this.muiscIsPlay = true
            }
        }
    },
    methods: {
        musicSwitch(){
            var _this = this; 
            var player = document.getElementById('musicplay');
            if(player.paused){
                console.log(player.paused)
                player.play();
                _this.muiscIsPlay = true
            }else{
                console.log(player.paused)
                player.pause();
                _this.muiscIsPlay = false
            }
        }
    },
}
</script>
<style lang="less" scoped>
@base:46.875rem;
#music{
    position: fixed;
    top: 30/@base;
    right: 30/@base;
    width: 80/@base;
    height: 80/@base;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
    z-index: 999999999 !important;
    background-image: url(https://t.shundecity.com/bjls2021/Home/View/Phone/images/music.png);
    opacity: 1 i !important;
}
.musicshow{
    animation: music 10s linear infinite both;
}

@keyframes music {
    to {
        transform: rotate(1080deg);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/music.vue